import React from 'react'
import styled from 'styled-components'

// ArComponents
import ArHeroHeader from 'src/components/ArHeroHeader/ArHeroHeader'
import ArSeo from 'src/components/ArSeo/ArSeo'

// Data
import DaPageBetaCommunity from 'src/data/PageBetaCommunity'
import ArPostSimple from 'src/components/ArPostSimple/ArPostSimple'
import Ar3ColFeatures from 'src/components/Ar3ColFeatures/Ar3ColFeatures'
import ArDynamicForm from 'src/components/forms/ArDynamicForm'
import ArBaseContainer from 'src/components/ArBaseContainer/ArBaseContainer'
import deviceInfoProvider from 'src/utils/deviceInfoProvider'
import ArSocialSection from 'src/components/ArSocialSection/ArSocialSection'
import routesConfig from 'src/routes.config'

const StyledWrapper = styled.div`
  margin: 0 auto;
  max-width: 600px;
  padding-bottom: 50px;
`

class ContactPage extends React.Component {
  render () {
    return (
      <React.Fragment>
        <ArSeo
          title={DaPageBetaCommunity.metadata.title}
          description={DaPageBetaCommunity.metadata.desc}
          path={routesConfig.beta()}
        />

        {(() => {
          const { title, description, form, video, cta } = DaPageBetaCommunity.ArHeroHeader
          return (
            <ArHeroHeader
              variant="beta"
              form={form}
              title={title}
              description={description}
              video={video}
              cta={cta}
            />
          )
        })()}

        {(() => {
          const { title, description } = DaPageBetaCommunity.ArPostSimple
          return (
            <ArPostSimple
              title={title}
              description={description}
            />
          )
        })()}

        {(() => {
          const { title, description, features } = DaPageBetaCommunity.Ar3ColFeatures

          return (
            <Ar3ColFeatures
              title={title}
              description={description}
              features={features}
              twoTabletColumns={true}
            />
          )
        })()}

        {(() => {
          const { form, footerText } = DaPageBetaCommunity.ArDynamicForm

          return (
            <>
              <ArPostSimple
                title={'Apply to join our Beta Community'}
                description={['Enter your details below to register your interest.']}
                customMargin={true}
              />
              <ArBaseContainer>
                <StyledWrapper id="beta-community-form">
                  <ArDynamicForm form={form} footerText={footerText} />
                </StyledWrapper>
              </ArBaseContainer>
            </>
          )
        })()}

        {(() => {
          const { title, social, backgroundColor } = DaPageBetaCommunity.ArSocialSection

          return (
            <ArSocialSection
              title={title}
              social={social}
              backgroundColor={backgroundColor}
            />
          )
        })()}

      </React.Fragment>
    )
  }
}

export default deviceInfoProvider(ContactPage)
